import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import "./Header.scss";
import { useAuth } from "../context/AuthContext";
import { useCart } from "../context/CartContext";
import logoCodaco from "../assets/images/logo-codaco.png";

/* === Home icon === */
function HomeIcon({ className = "header__icon" }) {
  return (
    <svg
      className={className}
      width="22"
      height="22"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path fill="currentColor" d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
    </svg>
  );
}

/* === Cart icon === */
function CartIcon({ className = "header__icon" }) {
  return (
    <svg
      className={className}
      width="22"
      height="22"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        fill="currentColor"
        d="M7 18a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm10 0a2 2 0 1 0 .001 4.001A2 2 0 0 0 17 18zM6.2 6l.4 2H20a1 1 0 0 1 .97 1.243l-1.8 7.2A2 2 0 0 1 17.24 18H8a2 2 0 0 1-1.96-1.608L4.14 4H2V2h3a1 1 0 0 1 .98.804L6.2 6zM8 16h9.24l1.5-6H7.1l.9 4.592A2 2 0 0 0 10 16z"
      />
    </svg>
  );
}

export default function Header() {
  const { user, logout } = useAuth();
  const { cartCount, clearCart } = useCart();
  const location = useLocation();
  const navigate = useNavigate();

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // Detect screen width to switch between icons and text
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isWelcome =
    location.pathname === "/" || location.pathname === "/products";

  const handleLogout = async () => {
    try {
      clearCart();
      await logout();
      navigate("/", { replace: true });
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  const headerClass = `header ${
    user
      ? user.email === "admin@codaco.cz" || user.email === "root@codaco.cz"
        ? "header--admin"
        : "header--user"
      : ""
  }`;

  return (
    <header className={headerClass}>
      <div className="header__brand">
        <a
          href="https://www.codaco.cz"
          className="header__logo"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={logoCodaco}
            alt="CODACO logo"
            className="header__logo-img"
          />
        </a>
      </div>

      <nav className="header__nav">
        {user && (
          <>
            {isWelcome ? (
              <button onClick={handleLogout} className="header__logout">
                {isMobile ? <i className="ri-logout-box-line"></i> : "Odhlásit"}
              </button>
            ) : (
              <>
                {/* Home */}
                <Link
                  to="/products/merch"
                  className="header__icon-link"
                  aria-label="Domů"
                  title="Domů"
                >
                  <HomeIcon />
                </Link>

                {/* Cart */}
                <Link
                  to="/cart"
                  className="header__icon-link header__cart"
                  aria-label="Košík"
                  title="Košík"
                >
                  <CartIcon />
                  {cartCount > 0 && (
                    <span className="header__cart-badge">{cartCount}</span>
                  )}
                </Link>

                {/* Admin-only links */}
                {user.email === "admin@codaco.cz" && (
                  <>
                    <Link
                      to="/admin"
                      className="header__link"
                      title="Admin sekce"
                    >
                      {isMobile ? (
                        <i className="ri-tools-line"></i>
                      ) : (
                        "Admin sekce"
                      )}
                    </Link>
                    <Link
                      to="/admin/orders"
                      className="header__link"
                      title="Objednávky"
                    >
                      {isMobile ? (
                        <i className="ri-list-check-2"></i>
                      ) : (
                        "Objednávky"
                      )}
                    </Link>
                  </>
                )}

                {/* Root-only link */}
                {user.email === "root@codaco.cz" && (
                  <Link to="/root" className="header__link" title="Root panel">
                    {isMobile ? (
                      <i className="ri-shield-user-line"></i>
                    ) : (
                      "Root panel"
                    )}
                  </Link>
                )}

                {/* Logout */}
                <button onClick={handleLogout} className="header__logout">
                  {isMobile ? (
                    <i className="ri-logout-box-line"></i>
                  ) : (
                    "Odhlásit"
                  )}
                </button>
              </>
            )}
          </>
        )}
      </nav>
    </header>
  );
}
